// skipcq: JS-W1028, JS-0128
import React from 'react';
import Card from '@mui/material/Card';

/** Compose base card layout with caller `sx` (object, array, or theme callback). */
function mergeSurfaceSx(sx, baseSx) {
  if (sx == null) {
    return baseSx;
  }
  if (Array.isArray(sx)) {
    return [baseSx, ...sx];
  }
  if (typeof sx === 'function') {
    return (theme) => {
      const resolved = sx(theme);
      if (resolved == null) {
        return baseSx;
      }
      return Array.isArray(resolved) ? [baseSx, ...resolved] : [baseSx, resolved];
    };
  }
  return [baseSx, sx];
}

/**
 * Dashboard metric card — uses global MuiCard vintage styling; centralizes layout sx.
 */
function DashboardSurfaceCard({ children, sx, ...rest }) {
  const baseSx = {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  };
  const mergedSx = mergeSurfaceSx(sx, baseSx);

  return (
    <Card sx={mergedSx} {...rest}>
      {children}
    </Card>
  );
}

export default DashboardSurfaceCard;
